<template>
  <main>
    <header-view>营养素</header-view>

    <!-- 营养素状态图 -->
    <waterfall-card
        v-if="nutritionStatus.length > 0"
        title="营养素状态图"
        :list="nutritionStatus"
        labelKey="item_dict_name_simple"
        colorKey="color"
        :valueKey="statusValueKey"
    ></waterfall-card>

    <!-- 详细数据报告表 -->
    <table-card title="详细数据报告表" :columns="columns" :list="list" custom v-slot="row">
      <router-link :to="{ path: '/nutrition', query: { code: row.system_code, title: row.item_dict_name, ...query } }"></router-link>
    </table-card>

    <list-card title="营养素调理建议" :list="nutritions" titleKey="item_dict_name" contentKey="condition_content"></list-card>
  </main>
</template>

<script>
  import HeaderView from "@/components/HeaderView";
  import WaterfallCard from "@/components/WaterfallCard";
  import TableCard from "@/components/TableCard";
  import ListCard from "@/components/ListCard";
  import {getReportLoopItemNutritionAll} from "../net/api";

  /**
   * 营养素概览
   */
  export default {
    name: "Nutritions",
    components: {ListCard, TableCard, WaterfallCard, HeaderView},

    data() {
      return {
        packageNo: '',
        checkcode: '',
        rand: '',

        // 通用态图列表数据关联项
        statusValueKey: {
          av: '均值'
        },

        // 营养素状态图
        nutritionStatus: [],

        // 列表关联项
        columns: {
          item_dict_name: '检测项目',
          av: '均值'
        },
        list: [],

        nutritions: []
      }
    },

    computed: {
      // 基础参数数据
      query() {
        return {
          packageNo: this.packageNo, rand: this.rand,  checkcode: this.checkcode
        }
      }
    },

    created() {
      const query = this.$router.currentRoute.query;
      this.packageNo = query.packageNo;
      this.checkcode = query.checkcode;
      this.rand = query.rand;

      this.syncPageData();
    },

    methods: {
      // 同步页面数据
      syncPageData() {
        // 获取报告数据
        getReportLoopItemNutritionAll({
          packageNo: this.packageNo,
          rand: this.rand,
          checkcode: this.checkcode
        }).then((data) => {
          this.nutritionStatus = data.show_zhuangtaitu;
          this.list = data.show_xiangxishuju;
          this.nutritions = data.show_tiaolijianyi;
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>